import { Navigate, useParams } from "react-router-dom";
import Professionals from "./professional";
import { ALL_REGIONS_CODE, regionPath } from "@/features/regions/constants";

function slugToSearchTerm(slug: string): string {
  return slug
    .replace(/^dr-/i, "")
    .replace(/-/g, " ")
    .trim();
}

export function OurMedicalTeamRedirect() {
  const { slug, region = ALL_REGIONS_CODE } = useParams();
  if (!slug) return <Navigate to={regionPath(region, "/professionals")} replace />;
  const search = slugToSearchTerm(slug);
  return (
    <Navigate
      to={regionPath(region, `/professionals?search=${encodeURIComponent(search)}`)}
      replace
    />
  );
}

export default function OurMedicalTeam() {
  return <Professionals />;
}
